import { AxiosProgressEvent, isAxiosError } from 'axios';
import { useMutation } from '@tanstack/react-query';
import axiosClient from '../common/AxiosClient';

interface Props {
  data: any;
  onUploadProgress: ((progressEvent: AxiosProgressEvent) => void) | undefined;
}

// Translation key for a failed upload: the API allows a few uploads per user every 10 minutes.
export const uploadJobDescriptionErrorKey = (error: unknown) =>
  isAxiosError(error) && error.response?.status === 429
    ? 'messages.tooManyUploads'
    : 'messages.fileUploadError';

export const useUploadJobDescription = () => {
  return useMutation({
    mutationFn: ({ data, onUploadProgress }: Props) => {
      const formData = new FormData();
      formData.append('file', data);

      return axiosClient.post('/standardlibrary/jobs/uploadjobdescription', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress,
      });
    },
  });
};
